module.exports = __webpack_public_path__ + "static/media/esdeem.8fca321b.png";